import React, { ReactElement } from 'react';
import { FormInstance } from 'antd/lib/form';

import { CLIENT_STATUS } from '../../../types/Client';

import AutoStackingFeatureFormSection from '../../../components/Feature/AutoStackingFeatureFormSection';

import { useClientFormContext } from '../ClientFormContext';
import ClientFormHeader from '../../../components/Client/ClientFormHeader';
import ClientForm from '../ClientForm';
import { submitAutostackingFactory } from '../utils/submit';

const ClientBaseForm: React.FC = (): React.ReactElement => {
    const { client, data, formConfig, resetFormFlag, setData } = useClientFormContext();

    const submitForm = async (form: FormInstance): Promise<void> => {
        if (!client) return;

        const autostacking = await submitAutostackingFactory(client.id, data.autostacking)(form);
        setData({ ...data, autostacking });
    };

    return (
        <>
            <div className="shadow-sm pb-4">
                <ClientFormHeader />
                <div className="px-4">
                    <ClientForm name="autostacking" submitForm={submitForm}>
                        {({ form }): ReactElement => (
                            <AutoStackingFeatureFormSection
                                formInstance={form}
                                autostacking={data.autostacking}
                                isDetailMode={formConfig.isDetailMode}
                                resetFormFlag={resetFormFlag}
                                enableControls={client?.status !== CLIENT_STATUS.DELETED}
                            />
                        )}
                    </ClientForm>
                </div>
            </div>
        </>
    );
};

export default ClientBaseForm;
